import { safeCopy } from "@/common/util"

export default function storeReset({ store }) {
  const initialState = safeCopy(store.$state)
  store.$reset = () => store.$patch(safeCopy(initialState))
}